'use client';

import { Toolbar } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import { cssStyles } from '../../utils';

import type { ToolbarProps } from '@mui/material';

export interface ToolbarStyleProps extends ToolbarProps {
  isTransparent?: boolean;
  isScrolling?: boolean;
}

const toolbarContraction = 16;

export const StyledToolBar = styled( Toolbar, {
  shouldForwardProp: (prop) => prop !== 'isTransparent' && prop !== 'isScrolling',
} )<ToolbarStyleProps>(({ isTransparent, isScrolling, theme }) => ({
  // performant boxShadow
  // pseudo element opacity transition trick
  ...theme.mixins.toolbar,
  '&::after': {
    ...theme.mixins.toolbar,
    content: '""',
    position: 'absolute',
    zIndex: -1,
    width: '100%',
    [theme.breakpoints.up( 'md' )]: {
      height: isScrolling
        ? theme.mixins.toolbar['@media (min-width:600px)'].height - toolbarContraction
        : theme.mixins.toolbar.height,
    },
    opacity: isScrolling ? 1 : 0,
    transition: theme.transitions.create( ['opacity', 'height'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.short,
    } ),
    boxShadow: `-23px 24px 56px -24px ${
      alpha(
        theme.palette.mode === 'light'
          ? theme.palette.grey[500]
          : theme.palette.common.black,
        1
      )
    }`,
    // [theme.breakpoints.up( 'xs' )]: {
    //   ...(isScrolling && {
    //     ...cssStyles( theme ).bgBlur(),
    //     height: theme.mixins.toolbar.height - 10,
    //   }),
  },
  position: 'relative',
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.default,
  transition: theme.transitions.create( ['height', 'background-color'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.short,
  } ),
  ...(isTransparent && {
    color: theme.palette.common.white,
    backgroundColor: 'transparent',
  }),
  // ...(isScrolling && {
  //   ...cssStyles( theme ).bgBlur(),
  //   height: theme.mixins.toolbar.height - toolbarContraction,
  // }),
  [theme.breakpoints.up( 'md' )]: {
    ...(isScrolling && {
      ...cssStyles( theme ).bgBlur(),
      height: theme.mixins.toolbar['@media (min-width:600px)'].height - toolbarContraction,
    }),
  },
}));

// export const StyledToolBar = styled(
//   Toolbar,
//   {
//     shouldForwardProp: (prop) => prop
//       !== 'transparent'
//       && prop
//       !== 'scrolling'
//       && prop
//       !== 'height'
//   }
// )<ToolbarStyleProps>(
//   ( {
//     transparent,
//     scrolling,
//     height,
//     theme
//   } ) => (
//     {
//       height,
//       color: theme.palette.text.primary,
//       backgroundColor: theme.palette.background.default,
//       transition: theme.transitions.create( [ 'height', 'background-color' ], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.short,
//       } ),
//       [theme.breakpoints.up('md')]: { height },
//       ...transparent && {
//         color: theme.palette.common.white,
//         backgroundColor: 'transparent',
//       },
//       ...scrolling && {
//         ...cssStyles(theme).bgBlur(),
//         [theme.breakpoints.up('md')]: { height: height - 20 },
//       }
//       ,
//     }
//   )
// );
